/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Range_Title_AccentInputs */

const en_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range.`)
};

const es_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`de Des Moines.`)
};

const de_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range.`)
};

const zh_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`练习场。`)
};

const ar_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range.`)
};

const fr_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practice.`)
};

const vi_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range.`)
};

const sw_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range.`)
};

const th_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สนามไดร์ฟกอล์ฟ`)
};

const bs_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range.`)
};

const ja_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドライビングレンジ。`)
};

const ko_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`드라이빙 레인지.`)
};

const pt_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range.`)
};

const it_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range.`)
};

const sv_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range.`)
};

const nl_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range.`)
};

const da_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range.`)
};

const nb_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range.`)
};

const fi_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range.`)
};

const pl_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range.`)
};

const ru_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range.`)
};

const tr_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range.`)
};

const hi_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ड्राइविंग रेंज।`)
};

const id_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range.`)
};

const ms_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range.`)
};

const cs_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range.`)
};

const el_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range.`)
};

const he_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range.`)
};

const af_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range.`)
};

const hu_range_title_accent = /** @type {(inputs: Range_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range.`)
};

/**
* | output |
* | --- |
* | "Driving Range." |
*
* @param {Range_Title_AccentInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const range_title_accent = /** @type {((inputs?: Range_Title_AccentInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Range_Title_AccentInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_range_title_accent(inputs)
	if (locale === "de") return de_range_title_accent(inputs)
	if (locale === "zh") return zh_range_title_accent(inputs)
	if (locale === "ar") return ar_range_title_accent(inputs)
	if (locale === "fr") return fr_range_title_accent(inputs)
	if (locale === "vi") return vi_range_title_accent(inputs)
	if (locale === "sw") return sw_range_title_accent(inputs)
	if (locale === "th") return th_range_title_accent(inputs)
	if (locale === "bs") return bs_range_title_accent(inputs)
	if (locale === "ja") return ja_range_title_accent(inputs)
	if (locale === "ko") return ko_range_title_accent(inputs)
	if (locale === "pt") return pt_range_title_accent(inputs)
	if (locale === "it") return it_range_title_accent(inputs)
	if (locale === "sv") return sv_range_title_accent(inputs)
	if (locale === "nl") return nl_range_title_accent(inputs)
	if (locale === "da") return da_range_title_accent(inputs)
	if (locale === "nb") return nb_range_title_accent(inputs)
	if (locale === "fi") return fi_range_title_accent(inputs)
	if (locale === "pl") return pl_range_title_accent(inputs)
	if (locale === "ru") return ru_range_title_accent(inputs)
	if (locale === "tr") return tr_range_title_accent(inputs)
	if (locale === "hi") return hi_range_title_accent(inputs)
	if (locale === "id") return id_range_title_accent(inputs)
	if (locale === "ms") return ms_range_title_accent(inputs)
	if (locale === "cs") return cs_range_title_accent(inputs)
	if (locale === "el") return el_range_title_accent(inputs)
	if (locale === "he") return he_range_title_accent(inputs)
	if (locale === "af") return af_range_title_accent(inputs)
	if (locale === "hu") return hu_range_title_accent(inputs)
	return en_range_title_accent(inputs)
});